import { DefaultTag } from './styles';
import { StyledSystem } from '@project44/manifest-ui-deprecated';

interface StyledTagProps {
  children: React.ReactNode;
  sx?: StyledSystem.SystemStyleObject;
}

export function StyledTag({ children, sx }: StyledTagProps) {
  return (
    <DefaultTag
      data-testid="identifier-tag"
      sx={{
        ...sx,
      }}
      variant="filled"
      size="small"
    >
      {children}
    </DefaultTag>
  );
}
